// eslint-disable-next-line no-unused-vars
import React from 'react';
import {Navigate} from "react-router-dom";

function Logout() {
    localStorage.removeItem("profile")
    return  <Navigate to="/login" replace />

}

export default Logout
